import { styled } from 'styled-components';
import { FunctionComponent } from 'react';
import { MediaGalleryDesktopAd } from './subcomponents/MediaGalleryDesktopAd/MediaGalleryDesktopAd';
import { mediaHelper } from '@property.com.au/ui-kit';
import { MediaGalleryMobileAd } from './subcomponents/MediaGalleryMobileAd/MediaGalleryMobileAd';
import { MediaGalleryCarouselWithData } from './subcomponents/MediaGalleryCarousel/MediaGalleryCarouselWithData';
import { IMediaGalleryModal } from '../../contexts/MediaGalleryModalContext/MediaGalleryModalContext';

const ContentWrapper = styled.div`
  /* 320px is our min supported mobile width and height considering portrait and landscape. Will force scrolling at lower */
  min-height: 320px;
  min-width: 320px;
  height: 100vh;
  height: 100dvh; /* stylelint-disable-line plugin/no-unsupported-browser-features */
  overflow: hidden;

  display: flex;
  flex-direction: row;

  ${mediaHelper('tabletMax')} {
    margin: auto;
    width: 100%;
    flex-direction: column;
    /* needed so takes remaining space available */
    flex: 1;
    /* needed so can shrink under 100% */
    min-width: 0;
  }
`;
interface MediaGalleryModalContentProps {
  opened: boolean;
  onClose: () => void;
  initialImageIndex?: number;
  galleryItemKey?: string;
  openAction: IMediaGalleryModal['openAction'];
}

export const MediaGalleryModalContent: FunctionComponent<MediaGalleryModalContentProps> = ({
  opened,
  onClose,
  initialImageIndex,
  galleryItemKey,
  openAction,
}) => {
  return (
    <ContentWrapper>
      <MediaGalleryCarouselWithData
        opened={opened}
        onClose={onClose}
        initialImageIndex={initialImageIndex}
        galleryItemKey={galleryItemKey}
        openAction={openAction}
      />
      <MediaGalleryDesktopAd />
      <MediaGalleryMobileAd />
    </ContentWrapper>
  );
};
